/* Silverbloom Paris — reveal au scroll + parallax, compatible éditeur de thème */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var parallaxEls = [];

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.sb-reveal:not(.is-visible)');
    if (reduced || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('is-visible');
      else io.observe(el);
    });
  }

  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-sb-parallax]'));
  }

  if (!reduced) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking || !parallaxEls.length) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900) * 0.12;
        parallaxEls.forEach(function (m) { m.style.transform = 'translateY(' + y + 'px)'; });
        ticking = false;
      });
    }, { passive: true });
  }

  initReveal(document);
  collectParallax();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    collectParallax();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    while (el && el !== document.body) { el.classList.add('is-visible'); el = el.parentElement; }
  });
})();
